import { AdminLayout } from '@/components/layouts'
import { FaqItemForm } from './FaqItemForm'

interface Community {
  id: number
  name: string
}

interface FaqItemDetail {
  id: number
  question: string
  answer: string
  position: number
  community_id: number | null
}

interface EditProps {
  faq_item: FaqItemDetail
  communities: Community[]
  max_position: number
}

export default function Edit({ faq_item, communities, max_position }: EditProps) {
  return (
    <AdminLayout
      title="Modifier la question"
      breadcrumbs={[
        { label: 'FAQ', href: '/admin/faq_items' },
        { label: `Question #${faq_item.id}`, href: `/admin/faq_items/${faq_item.id}` },
        { label: 'Modifier' }
      ]}
    >
      <div className="max-w-2xl">
        <FaqItemForm
          faqItem={{
            id: faq_item.id,
            question: faq_item.question,
            answer: faq_item.answer,
            community_id: faq_item.community_id || '',
            position: faq_item.position
          }}
          communities={communities}
          maxPosition={max_position}
          onSubmit={`/admin/faq_items/${faq_item.id}`}
          isEdit
        />
      </div>
    </AdminLayout>
  )
}
